import { Button } from 'components/buttons/button';
import {
  inputClassNames,
  labelClassNames,
  StandardInput,
} from 'components/forms/input';
import gql from 'graphql-tag';
import { useInput } from 'lib/hooks/use-input';
import {
  useGetShopDetailsQuery,
  GetShopDetailsQuery,
  useUpdateUnstructuredDataMutation,
} from 'lib/graphql-generated';
import currency from 'currency.js';

const GET_DETAILS = gql`
  query GetShopDetails {
    unstructured_data(where: { title: { _in: ["address", "opening_hours"] } }) {
      title
      data
    }

    booksellers {
      id
      name
      about
    }
  }
`;

const UPDATE_UNSTRUCTURED = gql`
  mutation UpdateUnstructuredData($title: String!, $data: jsonb) {
    update_unstructured_data_by_pk(
      pk_columns: { title: $title }
      _set: { data: $data }
    ) {
      title
    }
  }
`;

export const DetailsSection = () => {
  const address = useInput<string>('');
  const openingHours = useInput<string>('');

  const { data, loading, refetch } = useGetShopDetailsQuery({
    onCompleted: (data) => {
      handleInit(data);
    },
  });
  const [save, { loading: saving }] = useUpdateUnstructuredDataMutation({
    onCompleted: () => {
      refetch().then(({ data }) => handleInit(data));
    },
  });

  const handleInit = (data: GetShopDetailsQuery) => {
    if (data?.unstructured_data.length > 0) {
      address.init(
        data?.unstructured_data.find((data) => data.title === 'address').data
          .data
      );
      openingHours.init(
        data?.unstructured_data.find((data) => data.title === 'opening_hours')
          .data.data
      );
    }
  };
  return (
    <article className='bg-white shadow rounded-md  py-6 px-4 sm:p-6 flex flex-row flex-wrap'>
      <header className='w-full'>
        <h2 className='header text-xl text-gray-900'>Shop Details</h2>
        <p className='mt-1 text-sm text-gray-500'>
          Set the price of gift wrapping for web purchases.
        </p>
      </header>
      <form
        action=''
        className='mt-6 space-y-6 gap-6 w-full md:flex-1 md:pr-4 '>
        <label className={labelClassNames} htmlFor='address'>
          Address
          <textarea
            id='address'
            value={address.value}
            onChange={(e) => address.setValue(e.target.value)}
            className={inputClassNames}
          />
        </label>

        <section className='col-span-full'>
          <Button
            buttonType='primary'
            disabled={!address.isModified || saving || loading}
            loading={saving || loading}
            onClick={() => {
              save({
                variables: {
                  title: 'address',
                  data: { data: address.value },
                },
              });
            }}>
            Save
          </Button>
        </section>
      </form>
      <form action='' className='mt-6 space-y-6 gap-6 w-full md:flex-1 md:pl-4'>
        <label className={labelClassNames} htmlFor='address'>
          Opening Hours
          <textarea
            id='address'
            value={openingHours.value}
            onChange={(e) => openingHours.setValue(e.target.value)}
            className={inputClassNames}
          />
        </label>

        <section className='col-span-full'>
          <Button
            buttonType='primary'
            disabled={!openingHours.isModified || saving || loading}
            loading={saving || loading}
            onClick={() => {
              save({
                variables: {
                  title: 'opening_hours',
                  data: { data: openingHours.value },
                },
              });
            }}>
            Save
          </Button>
        </section>
      </form>
    </article>
  );
};
